__turbopack_context__.v({
  "icon": "LogoLoader-module__UAG-sW__icon",
  "rotate": "LogoLoader-module__UAG-sW__rotate",
});
